export default {
    searchClient: null,
    gsap: null,
    utils: null,
    algoliaConfig: null,

    init: function (utils, gsap) {
        this.algoliaConfig = window.algolia_json ?? {};

        // Early checks
        const indexName = this.algoliaConfig.indexName ?? null;
        if (!indexName) {
            console.log("algolia_index_name n'est pas défini !");
            return;
        }

        this.utils = utils;
        this.gsap = gsap;

        // Init the algolia client
        const searchClient = this.initSearchClient();
        if (!searchClient) return;

        // Configure instantsearch
        const search = this.configureInstantSearch(indexName, searchClient);

        // Add the main fonctional widgets
        this.addMainWidgets(search);

        // Start and init the search
        search.start();
    },

    initSearchClient: function () {
        const ALGOLIA_APP_ID = 'TQNO8H7E9L';
        const ALGOLIA_SEARCH_KEY = '2c549f4b4834223a81831950ebfe731f';

        if (!window['algoliasearch/lite']) {
            console.log("Client Algolia non disponible");
            return null;
        }

        const {liteClient: algoliasearch} = window['algoliasearch/lite'];
        return algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
    },


    configureInstantSearch: function (indexName, searchClient) {
        return instantsearch({
            indexName: indexName,
            searchClient
        });
    },

    createAutocompleteRenderer: function (search) {
        const { connectAutocomplete } = instantsearch.connectors;

        const renderAutocomplete = (renderOptions, isFirstRender) => {
            const { indices, currentRefinement, refine, widgetParams } = renderOptions;

            if (isFirstRender) {
                widgetParams.container.innerHTML = `
                    <div class="searchAsideForm__group">
                        <button type="submit" class="searchAsideForm__group__icon">
                            <svg class="icon icon-search">
                                <use href="#icon-search"></use>
                            </svg>
                        </button>
                        <input type="text" placeholder="Votre recherche" title="Recherche" class="searchAsideForm__group__input js-algolia-autocomplete-input" name="${this.algoliaConfig.indexName}[query]">
                        <button type="button" class="searchAsideForm__group__close js-algolia-autocomplete-reset">
                            <svg class="icon icon-close">
                                <use href="#icon-close"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="searchAside__content js-algolia-autocomplete-results"></div>
                `;

                widgetParams.container.querySelector('.js-algolia-autocomplete-input').addEventListener('input', event => {
                    refine(event.currentTarget.value);
                });
                widgetParams.container.querySelector('.js-algolia-autocomplete-reset').addEventListener('click', () => {
                    refine();
                });
            }

            widgetParams.container.querySelector('.js-algolia-autocomplete-input').value = currentRefinement;

            if (currentRefinement) {
                widgetParams.container.querySelector('.js-algolia-autocomplete-results').innerHTML = indices.map(({ indexId, hits }) => `
                  ${hits.map( hit => `
                    <a href="${hit.link}" class="searchCard__inner" title="${hit.title}">
                        <div class="searchCardContent">
                            <div class="searchCardContent__icon">
                                <svg class="icon icon-search">
                                    <use href="#icon-search"></use>
                                </svg>
                            </div>
                            <div class="searchCardContent__title">${instantsearch.highlight({ attribute: 'title', hit })}</div>
                        </div>
                    </a>
                  `).join('')}
                `).join('');
            } else {
                widgetParams.container.querySelector('.js-algolia-autocomplete-results').innerHTML = '';
            }
        };

        return connectAutocomplete(renderAutocomplete);
    },

    addMainWidgets: function (search) {
        const { configure } = instantsearch.widgets;
        const customAutocomplete = this.createAutocompleteRenderer(search);

        search.addWidgets([
            configure({
                hitsPerPage: 20,
            }),

            customAutocomplete({
                container: document.querySelector('.js-algolia-autocomplete'),
            })
        ]);
    },
}